import React, { useState, useEffect, useCallback } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import './suppliers.css';
interface Supplier {
    id: number;
    name: string;
    contact_name: string;
    phone: string;
    address: string;
}

export default function SupplierComponent() {
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [selectedSupplier, setSelectedSupplier] = useState<Supplier | null>(null);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [editName, setEditName] = useState<string>('');
    const [editContactName, setEditContactName] = useState<string>('');
    const [editPhone, setEditPhone] = useState<string>('');
    const [editAddress, setEditAddress] = useState<string>('');
    const [newSupplierName, setNewSupplierName] = useState<string>('');
    const [newContactName, setNewContactName] = useState<string>('');
    const [newPhone, setNewPhone] = useState<string>('');
    const [newAddress, setNewAddress] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>(''); // State for search term

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = useCallback(async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const userResponse = await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setUserRole(userResponse.data.user.role);
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    }, [dispatch]);

    const fetchSuppliers = useCallback(async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/suppliers/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setSuppliers(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20)); // Assuming 20 items per page
        } catch (error) {
            console.error('Error fetching suppliers:', error);
        }
        setLoading(false);
    }, [searchTerm]);

    useEffect(() => {
        fetchData();
    }, [dispatch, fetchData]);

    useEffect(() => {
        if (auth) {
            fetchSuppliers(currentPage);
        }
    }, [auth, currentPage, searchTerm, fetchSuppliers]); // Add searchTerm to dependencies

    const handleEdit = (supplier: Supplier) => {
        setSelectedSupplier(supplier);
        setEditName(supplier.name);
        setEditContactName(supplier.contact_name);
        setEditPhone(supplier.phone);
        setEditAddress(supplier.address);
        setShowEditModal(true);
    };

    const handleSaveEdit = async () => {
        if (selectedSupplier) {
            try {
                await axios.put(`https://api.sominnovations.xyz/Branches/suppliers/${selectedSupplier.id}/`, {
                    name: editName,
                    contact_name: editContactName,
                    phone: editPhone,
                    address: editAddress,
                });
                setSuppliers(suppliers.map(supplier =>
                    supplier.id === selectedSupplier.id
                        ? { ...supplier, name: editName, contact_name: editContactName, phone: editPhone, address: editAddress }
                        : supplier
                ));
                setShowEditModal(false);
            } catch (error) {
                console.error('Error updating supplier:', error);
            }
        }
    };

    const handleCreateSupplier = async () => {
        try {
            const response = await axios.post('https://api.sominnovations.xyz/Branches/suppliers/', {
                name: newSupplierName,
                contact_name: newContactName,
                phone: newPhone,
                address: newAddress,
            });
            setSuppliers([...suppliers, response.data]);
            setShowCreateModal(false);
            setNewSupplierName('');
            setNewContactName('');
            setNewPhone('');
            setNewAddress('');
        } catch (error) {
            console.error('Error creating supplier:', error);
        }
    };



    const handleDelete = async (id: number) => {
        if (window.confirm("Are you sure you want to delete supplier?")) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/suppliers/${id}/`);
                setSuppliers(suppliers.filter(supplier => supplier.id !== id));
                console.log('Deleted supplier with ID:', id);
            } catch (error) {
                console.error('Error deleting supplier:', error);
            }
        }
    };

    return (
        <div className="container mt-1 suppliers-container">
            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>Suppliers</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href="dashboard"><p style={{ color: "white" }}>Dashboard</p></Breadcrumb.Item>
                            <Breadcrumb.Item active>Suppliers</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Button variant="warning" onClick={() => setShowCreateModal(true)}>
                        + Add Supplier
                    </Button>
                </Card.Body>
            </Card>

            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Suppliers..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
                />
            </div>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className='table-responsive-sm'>
                        <table className="table table-striped">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Contact Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {suppliers.map((supplier, index) => (
                                    <tr key={supplier.id}>
                                        <td>{index + 1 + (currentPage - 1) * 20}</td>
                                        <td>{supplier.name}</td>
                                        <td>{supplier.contact_name}</td>
                                        <td>{supplier.phone}</td>
                                        <td>{supplier.address}</td>
                                        <td>
                                            {/* <button
                                            className="btn btn-info btn-sm me-2"
                                            onClick={() => handleView(supplier.id)}
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                            View
                                        </button> */}
                                            <button
                                                className="btn btn-warning btn-sm me-2"
                                                onClick={() => handleEdit(supplier)}
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                                Edit
                                            </button>
                                            {userRole !== 'accountant' && (
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(supplier.id)}
                                                >
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                    Delete
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination>
                        <Pagination.Prev
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </>
            )}

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Supplier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Supplier Name"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Contact Name"
                            value={editContactName}
                            onChange={(e) => setEditContactName(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Phone"
                            value={editPhone}
                            onChange={(e) => setEditPhone(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Address"
                            value={editAddress}
                            onChange={(e) => setEditAddress(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Close</Button>
                    <Button variant="warning" onClick={handleSaveEdit}>Save Changes</Button>
                </Modal.Footer>
            </Modal>

            {/* Create Modal */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Supplier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Supplier Name"
                            value={newSupplierName}
                            onChange={(e) => setNewSupplierName(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Contact Name"
                            value={newContactName}
                            onChange={(e) => setNewContactName(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Phone"
                            value={newPhone}
                            onChange={(e) => setNewPhone(e.target.value)}
                        />
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Address"
                            value={newAddress}
                            onChange={(e) => setNewAddress(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>Close</Button>
                    <Button variant="warning" onClick={handleCreateSupplier}>Create Supplier</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
